






























import { SdsToggleSwitch } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabledLabel: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: [
        'input',
    ],
    setup(_, { emit }) {
        function updateValue(newState: boolean): void {
            emit('input', newState);
        }

        return { updateValue };
    },
    components: {
        SdsToggleSwitch,
    },

});
